import React, { useContext } from 'react';
import styled from 'styled-components';
import { AppContext } from 'src/components/app-context';
import { layout } from 'src/components/base';
import { TitleMediumText } from '@prisjakt/ui/text/variants';

import { getTranslationByContentType } from 'src/areas/expert/utils';

import { ContentTypes } from '../../types';

type Props = {
  type: ContentTypes;
};

export const Badge = (props: Props) => {
  const { type } = props;
  const { t } = useContext(AppContext);
  const text = getTranslationByContentType(type, t);

  return text ? <Text>{text}</Text> : null;
};

export const Text = styled(TitleMediumText)`
  && {
    font-size: ${layout.measurements.fontSizeMedium};
    color: ${p => p.theme.colors.maybeBlue700};
  }
`;
